import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}product`;

export const getProducts = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const getMasterProducts = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/product/get-master-product`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const getProductById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const createProduct = (product) => {
    const token = localStorage.getItem('token');

    return axios.post(API_URL_WEB, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const updateProduct = (id, product) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL_WEB}/${id}`, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const updateDescriptionProduct = (id, product) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL_WEB}/description/${id}`, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const deleteProduct = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

// findOneCategoriesProductByidProduct

export const findOneCategoriesProductByidProduct = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/findOneCategoriesProductByidProduct/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
        },
    });
}

export const updateActive = (id, product) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/active-product/${id}`,
        product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}